'use strict';

var KEY_USER = 'user';

angular.module('webAgro1App').controller('LoginCtrl', function($scope, $route, $location, $rootScope,
    LoginService, CommonHTTPService, StorageService) {

  $rootScope.bodyClass = 'login';

  $scope.doLogin = function(dataLogin) {
    $scope.error = null;
    $scope.loading = true;
    LoginService.authenticate(dataLogin).then(function(data) {
      StorageService.set(KEY_USER, data.data);
      $rootScope.initWeb();
      $location.path('/');
    }, function(error) {
      if (CommonHTTPService.isUnauthorized(error.status)) {
        $scope.error = 'Usuário/Senha inválido';
      } else {
        $scope.error = 'Ocorreu um erro, tente novamente';
      }
    }).finally(function() {
      $scope.loading = false;
    });
  };
});
